import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'caja-list',
	templateUrl: './caja-list.component.html',
	styleUrls: ['./caja-list.component.css'],
})
export class CajaListComponent implements OnInit {
	public title: String;
	public dataGrid: any;

	constructor() {
		this.title = "Precios de Producto";
		
		this.dataGrid = {
			keyGrid: "caja",
			qs: "&embed=sucursal",
			perPage: 10,
			endPoint: "/cajas",
			routeEdit: "/ventas/cajas-edit",
			columsDef: [
				{
					Header: "Sucursal",
					Field: "sucursal.nombre"
				},
				{
					Header: "Establecimiento",
					Field: "sucursal.establecimiento"
				},
				{
					Header: "Caja",
					Field: "nombre",
					Searchable: true
				},
				{
					Header: "Punto de emisión",
					Field: "punto_emision",
					Searchable: true
				}
			]
		};
	}

	ngOnInit() {
		//
	}
}




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/caja-list/caja-list.component.ts